import { useGenUiConfig } from './config.js';
import {
  genUiT,
  resolveGenUiLocale,
  type GenUiLocale,
  type GenUiTranslate,
} from '@voll-intelligence/genui-contract';

export {
  genUiT,
  resolveGenUiLocale,
  type GenUiKey,
  type GenUiLocale,
  type GenUiTranslate,
} from '@voll-intelligence/genui-contract';

/** O locale resolvido + `t` já fechado nele, sem Context: para quem recebe o
 *  locale por prop (as telas que um host monta fora do `GenUiConfigProvider`). */
export function genUiI18n(locale: string | null | undefined): {
  locale: GenUiLocale;
  t: GenUiTranslate;
} {
  const resolved = resolveGenUiLocale(locale);
  return {
    locale: resolved,
    t: (key, values) => genUiT(resolved, key, values),
  };
}

/**
 * Hook dos cards React: locale resolvido + `t` já fechado nele, lido da config.
 * Vive no kit, não no catálogo (`i18n_core.ts`, no contrato), porque depende de
 * `useGenUiConfig` — e `config.js` importa tipos de `@voll-intelligence/intelligence-ui-kit`
 * (100% React), que o contrato não carrega.
 */
export function useGenUiI18n(): {
  locale: GenUiLocale;
  t: GenUiTranslate;
} {
  return genUiI18n(useGenUiConfig().locale);
}
